<router-outlet></router-outlet>
<notifier-container></notifier-container>
<rs-spinner *ngIf="spinnerVisibility$ | async"></rs-spinner>
